<template>
  <div>
    <px-lista-selecao-fornecedores :comprador="requisicao.comprador"
                                   :produtos="requisicao.produtos"
                                   :is-editing="isEditing"
                                   v-model="requisicao.fornecedores"
                                   @resetfornecedor="emitReset"/>
    <div class="mt-3">
      <v-btn color="primary"
              class="rounded-tag-small normal-btn-text elevation-0"
              :loading="loading"
              :disabled="loadingSaveRascunho"
              @click="enviarRequisicao">
        Enviar
      </v-btn>
      <v-btn v-if="!isEdicao"
              class="rounded-tag-small elevation-0 normal-btn-text ml-2"
              :loading="loadingSaveRascunho"
              :disabled="loading"
              @click="saveDraft">
        Salvar rascunho
      </v-btn>
      <v-btn text
             class="normal-btn-text"
             :disabled="loading"
             @click="previous">
        Voltar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingSaveRascunho: {
      type: Boolean,
      default: false,
    },
    isEdicao: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitReset() {
      this.$emit('reset-fornecedor');
    },
    saveDraft() {
      this.$emit('save-draft');
    },
    previous() {
      this.$emit('previous');
    },
    enviarRequisicao() {
      this.$emit('enviar-requisicao');
    },
  },
};
</script>
